export enum MediaType {
  Gallery = 'gallery',
  Playlist = 'playlist',
  Embed = 'embed',
}
